export enum LegalEngineErrorCode {
  UNABLE_TO_COMPUTE = '19'
}
